<template>
  <div class="page">
    <header>
      <div class="view-title">{{ 'CompleteRelativeUserTitle' | lang }}</div>
    </header>
    <div>
      <h3 style="text-align: center;">{{ message }}</h3>
      <div vi-if="status!=waiting" class="small-form">
          <button class="full-width" @click="goHome()" >Homepage</button>
      </div>
    </div>
  </div>
</template>

<script>
import page from '@/mixins/routeControl'
import UserServices from '@/mixins/services/userServices'

export default {
  name: 'CompleteRelativeUser',
  mixins: [page, UserServices],
  data() {
    return {
      status: '',
      statusDetails: null,
    }
  },
  computed: {
    email() {
      return this.$route.query.email
    },
    security() {
      return this.$route.query.security
    },
    isWaiting() {
      return this.status === 'waiting'
    },
    message() {
      var message = '';
      switch (this.status) {
        case 'waiting':
          message = this.dictValue('AcceptRelativeUserWaiting');
          break;
        case 'success':
          message = this.dictValue('AcceptRelativeUserSuccess');
          break;
        case 'error':
          message = thsi.dictValue('AcceptRelativeUserError');
          break;
      }
      return message;

    }

  },
  methods: {
    confirm() {
      this.status = 'waiting'
      let promise = null
      promise = this._acceptRelativeUser({
        security: this.security
      })

      promise.then(data => {
        this.status = 'success'
        console.log(data)
        this.internalBus.$emit('notify:success', {
          text: this.dictValue('RegistrationDone'),
          key: this.notifierKey
        })


      }).catch(response => {
        this.status = 'error'
        let msg = this.dictValue('error') + (response.status === 418 ? '[VAD]' : '')
        console.log(response)
        if (typeof response.body === 'string') {
          msg = response.body
        } else {
          for (let k in response.body) {
            msg = response.body[k][0]
          }
        }
        this.internalBus.$emit('notify:error', {
          text: msg,
          key: this.notifierKey,
          timeout: 3000
        })
      })
    },
    goHome()
    {
      this.goTo('/')
    }
  },
  mounted() {
    this.confirm();
  },
  beforeDestroy() { },
  watch: {
  }
}
</script>

<style></style>
